import { render, staticRenderFns } from "./ContenidoCursoCurriculaVivo2.vue?vue&type=template&id=5087d240&scoped=true"
import script from "./ContenidoCursoCurriculaVivo2.vue?vue&type=script&lang=js"
export * from "./ContenidoCursoCurriculaVivo2.vue?vue&type=script&lang=js"
import style0 from "./ContenidoCursoCurriculaVivo2.vue?vue&type=style&index=0&id=5087d240&prod&scoped=true&lang=css"
import style1 from "./ContenidoCursoCurriculaVivo2.vue?vue&type=style&index=1&id=5087d240&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5087d240",
  null
  
)

export default component.exports